import Swiper from 'swiper'
import { A11y, Autoplay, EffectFade, Pagination } from 'swiper/modules'

export default {
  init: () => {
    document.querySelectorAll('.media-content').forEach((el) => {
      const container = el.querySelector('.swiper')

      new Swiper(container, {
        modules: [A11y, Autoplay, EffectFade, Pagination],
        speed: 1000,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: el.querySelector('.slider-pagination'),
          clickable: true,
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
      })
    })
  },
}
